$(document).ready(function () {

    var mediaQuery1 = window.matchMedia('(max-width: 789px)');
  // console.log(mediaQuery1,mediaQuery1.matches,'media qiery')
    if(mediaQuery1.matches){
        $('.footer__heading').on('click',function (e) {  
          e.preventDefault();
            $(this).toggleClass('open');
          return false;
        })
    }

   $(".loginBtn").click(function() {
        $("#loginPopup").show();
        $("#signupPopup").hide();
        $(".overlay").show();
    });

    $("#closeLogin, .overlay").click(function() {
        $("#loginPopup").hide();
        $(".overlay").hide();
    });

    $(".signupBtn").click(function() {
        $("#signupPopup").show();
        $("#loginPopup").hide();
        $(".overlay").show();
    });

    $("#closeSignup, .overlay").click(function() {
        $("#signupPopup").hide();
        $(".overlay").hide();
    });

});


var lp, rp, mItems, sc, pos;
lp = $(".left-pointer");
rp = $(".right-pointer");
mItems = $(".header__menu-items");

// Function to check and update arrow visibility
function checkArrows() {
    var newScrollLeft = mItems.scrollLeft(),
        width = mItems.width(),
        scrollWidth = mItems.get(0).scrollWidth;
    var offset = 8;

    // Check if at the right end
    if (scrollWidth - newScrollLeft - width < offset) {
        $(".right-pointer").addClass("dis");
    } else {
        $(".right-pointer").removeClass("dis");
    }

    // Check if at the left end
    if (newScrollLeft == 0) {
        $(".left-pointer").addClass("dis");
    } else {
        $(".left-pointer").removeClass("dis");
    }
}

// Click event for left pointer
lp.click(function () {
    sc = mItems.width() - 60;
    pos = mItems.scrollLeft() - sc;
    mItems.animate({ 'scrollLeft': pos }, 'slow', function () {
        checkArrows(); // Check arrow visibility after animation
    });
});

// Click event for right pointer
rp.click(function () {
    sc = mItems.width() - 60;
    pos = mItems.scrollLeft() + sc;
    mItems.animate({ 'scrollLeft': pos }, 'slow', function () {
        checkArrows(); // Check arrow visibility after animation
    });
});

// Initial check for arrow visibility
checkArrows();

// Add mouse drag functionality
const slider1 = document.querySelector('.header__menu-items');
let isDown = false;
let startX;
let scrollLeft;

slider1.addEventListener('mousedown', (e) => {
    isDown = true;
    slider1.classList.add('active');
    startX = e.pageX - slider1.offsetLeft;
    scrollLeft = slider1.scrollLeft;
});

slider1.addEventListener('mouseleave', () => {
    isDown = false;
    slider1.classList.remove('active');
});

slider1.addEventListener('mouseup', () => {
    isDown = false;
    slider1.classList.remove('active');
    checkArrows(); // Check arrow visibility after mouse up
});

slider1.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider1.offsetLeft;
    const walk = (x - startX) * 3; //scroll-fast
    slider1.scrollLeft = scrollLeft - walk;
});

// Check arrow visibility after drag
slider1.addEventListener('scroll', () => {
    checkArrows();
});

// Handle window resize event to update arrow visibility
$(window).resize(function() {
    checkArrows();
});

// Initial check on page load to handle different screen sizes
$(document).ready(function() {
    checkArrows();
});